import { Component, computed, inject, input, model, output } from '@angular/core';
import { UwIcon } from '../icon/uw-icon';
import { FocusTrapDirective } from '../../directives/focus-trap.directive';

export type DrawerSide = 'left' | 'right';

@Component({
  selector: 'uw-drawer',
  standalone: true,
  imports: [UwIcon, FocusTrapDirective],
  template: `
    @if (open()) {
      <div class="fixed inset-0 z-drawer">
        <div class="absolute inset-0 bg-black/40" (click)="open.set(false)" aria-hidden="true"></div>
        <div
          uwFocusTrap
          role="dialog"
          aria-modal="true"
          [attr.aria-label]="label()"
          class="absolute top-0 flex h-full w-80 max-w-[85vw] flex-col bg-surface-elevated shadow-lg transition-transform"
          [class]="side() === 'right' ? 'right-0' : 'left-0'"
          (keydown.escape)="open.set(false)"
        >
          <header class="flex items-center justify-between border-b border-line px-4 py-3">
            <h2 class="typo-title text-primary">{{ label() }}</h2>
            <button
              class="rounded p-1 text-text-muted transition-colors hover:bg-surface-sunken hover:text-primary"
              (click)="open.set(false)"
              [attr.aria-label]="'Close panel'"
            >
              <uw-icon name="x" [size]="16" />
            </button>
          </header>
          <div class="flex-1 overflow-y-auto">
            <ng-content />
          </div>
        </div>
      </div>
    }
  `,
})
export class UwDrawer {
  readonly open = model(false);
  readonly side = input<DrawerSide>('right');
  readonly label = input('Panel');

  readonly closed = output();

  protected readonly sideClass = computed(() => (this.side() === 'right' ? 'right-0' : 'left-0'));
}
